import { createContext } from 'react';

import { MintFromFixedPrice } from './types';

export const MintFromFixedPriceContext =
  createContext<MintFromFixedPrice | null>(null);
